import BreadCrumb from "Components/Common/BreadCrumb";
import {
  adminGetComboMember,
  adminGetEventAttendance,
} from "helpers/backend_helpers";
import { formatDate } from "helpers/globalFunction";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import SearchableSelect from "Components/Common/SearchableSelect";
import Loader from "Components/Common/Loader";
import TableContainer from "Components/Common/TableContainer";
import DetailModalEvent from "./DetailModalEvent";

const DetailEventList = () => {
  const params = useParams();
  const [tableData, setTableData] = useState<any>([]);
  const [data, setData] = useState<any>({});
  const [sort, setSort] = useState("createTime");
  const [dir, setDir] = useState(-1);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);

  const [detailModal, setDetailModal] = useState<boolean>(false);

  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [filterDate, setFilterDate] = useState<any>([]);
  const [filterMember, setFilterMember] = useState<any>(null);
  const [flatpickrKey, setFlatpickrKey] = useState(0);

  const getData = () => {
    setLoading(true);
    let query: any = {
      page: pagination.pageIndex,
      size: pagination.pageSize,
      sort: sort,
      dir: dir,
    };

    if (filterDate[0] && filterDate[1]) {
      query.startDate = moment(filterDate[0]).format("YYYY-MM-DD");
      query.endDate = moment(filterDate[1]).format("YYYY-MM-DD");
    }
    if (filterMember) {
      query.memberId = filterMember.value;
    }

    adminGetEventAttendance(params.id, query)
      .then((response: any) => {
        setTableData(
          response.content.map((el: any, index: any) => {
            const { createTime, checkOutTime, member } = el;
            return {
              ...el,
              index: index + pagination.pageIndex * pagination.pageSize + 1,
              tanggal: formatDate(createTime, "fullDateTime") || "-",
              namaUser: member?.name || "-",
              idUser: member?.noId || "-",
            };
          })
        );
        setRowCount(response.totalElements);
        setTotalPages(response.totalPages);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const searchMembers = async (name: string) => {
    const query = { name };
    return await adminGetComboMember(query);
  };

  const formatMemberOption = (member: any) => {
    return {
      label: `${member.name} - ${member.noId}`,
      value: member._id,
    };
  };

  const handleResetFilter = () => {
    setFilterDate([]);
    setFilterMember(null);
    setFlatpickrKey((prev) => prev + 1);
  };

  const handleToggleFilter = () => {
    if (showFilter) {
      handleResetFilter();
    }
    setShowFilter(!showFilter);
  };

  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "index",
        enableColumnFilter: false,
        enableSorting: false,
        size: 50,
      },
      {
        header: "Waktu Kehadiran",
        accessorKey: "tanggal",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Nama Karyawan",
        accessorKey: "namaUser",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "No Reg",
        accessorKey: "idUser",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Keterangan",
        accessorKey: "note",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Lokasi",
        accessorKey: "location.address",
        enableColumnFilter: false,
        enableSorting: false,
        size: 200,
      },

      {
        header: "Aksi",
        enableColumnFilter: false,
        enableSorting: false,
        size: 250,
        cell: (cellProps: any) => {
          return (
            <div className="hstack gap-2">
              <UncontrolledTooltip
                target={`detail-${cellProps.row.original._id}`}
              >
                Detail
              </UncontrolledTooltip>
              <button
                id={`detail-${cellProps.row.original._id}`}
                className="btn btn-sm btn-soft-info"
                onClick={() => {
                  setDetailModal(!detailModal);
                  setData(cellProps.row.original);
                }}
              >
                <i className="ri-eye-line" />
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    getData();
  }, [pagination, sort, dir, filterDate, filterMember]);

  document.title = "Detail Event";

  return (
    <React.Fragment>
      <div className="page-content">
        <DetailModalEvent
          show={detailModal}
          onCloseClick={() => setDetailModal(false)}
          data={data}
        />

        <Container fluid>
          <BreadCrumb title="Detail Event" pageTitle="Event" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="border-0">
                  <div className="d-flex align-items-center">
                    <h5 className="card-title mb-0 flex-grow-1">
                      Detail Event
                    </h5>
                    <div className="flex-shrink-0">
                      <div className="d-flex gap-2 flex-wrap">
                        <button
                          className="btn btn-soft-primary btn-sm"
                          onClick={handleToggleFilter}
                        >
                          <i className="ri-filter-3-line align-bottom me-1"></i>
                          Filters
                        </button>
                        {/* <button
                          className="btn btn-soft-dark btn-sm"
                          onClick={() => setDownloadModal(!downloadModal)}
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>
                          Unduh Data Absen
                        </button> */}
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="pt-0">
                  <Collapse isOpen={showFilter}>
                    <Row className="g-3 mb-4">
                      <Col lg={3}>
                        <div>
                          <Flatpickr
                            key={flatpickrKey}
                            className="form-control"
                            options={{
                              mode: "range",
                              dateFormat: "d M Y",
                            }}
                            onChange={(e) => {
                              setFilterDate(e);
                            }}
                            value={filterDate}
                            placeholder="Pilih Tanggal"
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <SearchableSelect
                          value={filterMember}
                          onChange={setFilterMember}
                          onSearch={searchMembers}
                          formatOptionLabel={formatMemberOption}
                          placeholder="Cari Karyawan"
                          minSearchLength={2}
                          itemsPerPage={5}
                          isClearable
                        />
                      </Col>

                      <Col lg={12}>
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-soft-secondary btn-sm"
                            onClick={handleResetFilter}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>
                            Reset
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Collapse>
                  <div>
                    {loading ? (
                      <Loader />
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={tableData || []}
                        customPageSize={10}
                        theadClass="text-muted text-uppercase"
                        manualPagination
                        pagination={pagination}
                        pageCount={totalPages}
                        onPaginationChange={setPagination}
                        divClass="table-responsive"
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default DetailEventList;
